export default __webpack_public_path__ + "static/bloomreach-71c3611e765d3e77d2b79e44a6c81d7b.svg";